import { useState } from 'react';
import ModerationDialog from './ModerationDialog';
import { MARKINGS, POSITIONS } from './ModerationDistribution';
import { getModerationGrade, type ModerationDecision, type ModerationRow } from './service';

export default function ModerationDecisionDialog({
  row,
  pending,
  error,
  onSave,
  onClose,
}: {
  row: ModerationRow;
  pending: boolean;
  error?: string;
  onSave: (decision: ModerationDecision) => void;
  onClose: () => void;
}) {
  const [marking, setMarking] = useState(row.finalMarking || '');
  const [position, setPosition] = useState(row.finalPosition || '');
  const period = row.period === 'Q2' ? 'Mid-Year' : 'End-of-Year';
  return (
    <ModerationDialog
      title={row.scsName}
      onClose={() => {
        if (!pending) onClose();
      }}
    >
      <form
        className="scs-moderation-dialog__content"
        onSubmit={(event) => {
          event.preventDefault();
          if (!pending) onSave({ complete: true, finalMarking: marking, finalPosition: position });
        }}
      >
        <p className="govuk-body">Grade: {getModerationGrade(row)}</p>
        <fieldset className="govuk-fieldset govuk-!-margin-bottom-6" disabled={pending}>
          <legend className="govuk-fieldset__legend govuk-fieldset__legend--s">
            Indicative {period} Performance Marking
          </legend>
          <p className="govuk-body">
            Indicative Marking: {row.indicativeMarking?.trim() || 'Not provided'}
          </p>
          <label className="govuk-label" htmlFor="moderation-final-marking">
            Final Marking
          </label>
          <select
            className="govuk-select"
            id="moderation-final-marking"
            required
            value={marking}
            onChange={(event) => setMarking(event.target.value)}
          >
            <option value="">Select a marking</option>
            {MARKINGS.map((value) => (
              <option key={value}>{value}</option>
            ))}
          </select>
        </fieldset>
        <fieldset className="govuk-fieldset govuk-!-margin-bottom-6" disabled={pending}>
          <legend className="govuk-fieldset__legend govuk-fieldset__legend--s">
            Indicative {period} Talent Position
          </legend>
          <p className="govuk-body">
            Indicative Position: {row.indicativePosition?.trim() || 'Not provided'}
          </p>
          <label className="govuk-label" htmlFor="moderation-final-position">
            Final Marking
          </label>
          <select
            className="govuk-select"
            id="moderation-final-position"
            required
            value={position}
            onChange={(event) => setPosition(event.target.value)}
          >
            <option value="">Select a position</option>
            {POSITIONS.map((value) => (
              <option key={value}>{value}</option>
            ))}
          </select>
        </fieldset>
        {error && (
          <p className="govuk-error-message" role="alert">
            {error}
          </p>
        )}
        <div className="govuk-button-group">
          <button type="submit" className="govuk-button" disabled={pending}>
            {row.moderationComplete ? 'Update' : 'Save'}
          </button>
          <button
            type="button"
            className="govuk-button govuk-button--warning"
            disabled={pending}
            onClick={() => (row.moderationComplete ? onSave({ complete: false }) : onClose())}
          >
            {row.moderationComplete ? 'Set moderation as not complete' : 'Cancel'}
          </button>
        </div>
      </form>
    </ModerationDialog>
  );
}
